module.exports = __webpack_public_path__ + "img/abilities.76fb9c92.svg";